/**
 * Very simple function to make sure a new unique number is always retrieved
 */
export const createNumberCounter = (): (() => number) => {
    let value = 0
    return () => ++value
}
